import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

const PageHeaderStyles = styled.div`
  margin: -1px auto;

  .page-header {
    text-align: center;
    line-height: 12px;
    color: ${Colors.primary.white.standard};
    background: ${Colors.primary.claytonBlue.standard};
    padding: 24px;
  }
`;

export default PageHeaderStyles;
